import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { Input } from '../../ui/input';

const StableNumberInput = forwardRef(({ 
  id, 
  value, 
  onChange, 
  placeholder, 
  min, 
  max, 
  step = "0.1",
  className = "w-full",
  readonly = false
}, ref) => {
  const inputRef = useRef(null);
  
  useImperativeHandle(ref, () => ({
    focus: () => inputRef.current?.focus(),
    blur: () => inputRef.current?.blur(),
    select: () => inputRef.current?.select()
  }));

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Input
      ref={inputRef}
      id={id}
      type="number"
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder}
      min={min}
      max={max}
      step={step}
      className={className}
      readOnly={readonly}
    />
  );
});

StableNumberInput.displayName = 'StableNumberInput';
export default React.memo(StableNumberInput);
